export const MuiMenuItem = {
  styleOverrides: {
    root: {
      color: '#170f5f',
      height: '5.6rem',
      fontSize: '1.6rem',
    },
  },
};
